export const clone = (obj) => {
    return JSON.parse(JSON.stringify(obj));
} 